export var TimeOffType = /*#__PURE__*/ function(TimeOffType) {
    TimeOffType["FullDay"] = "FULL_DAY";
    TimeOffType["HalfDay"] = "HALF_DAY";
    TimeOffType["Custom"] = "CUSTOM";
    return TimeOffType;
}({});
